export const REGEXP_LITERAL = /^\/(.+)\/([gimsuy]*)$/;
export const FILE_BLOCK_REGEX = /{%\s*file\s[^%]*?src="([^"]{1,2048})"/g;
export const IPV4_HOST_RE = /^(\d{1,3}\.){3}\d{1,3}(:\d+)?$/;
